/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, stepText: NonNullable<unknown> }} Insight_Progress_LoadInputs */

const en_us2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Time to add weight on ${i?.exercise}: +${i?.stepText}`)
};

const pt_br2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hora de subir a carga em ${i?.exercise}: +${i?.stepText}`)
};

const es_419_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hora de subir el peso en ${i?.exercise}: +${i?.stepText}`)
};

const pt_pt2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Altura de subir a carga em ${i?.exercise}: +${i?.stepText}`)
};

const fr_fr2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il est temps d'ajouter du poids sur ${i?.exercise} : +${i?.stepText}`)
};

const de_de2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeit für mehr Gewicht bei ${i?.exercise}: +${i?.stepText}`)
};

const it_it2_insight_progress_load = /** @type {(inputs: Insight_Progress_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`È ora di aumentare il carico su ${i?.exercise}: +${i?.stepText}`)
};

/**
* | output |
* | --- |
* | "Time to add weight on {exercise}: +{stepText}" |
*
* @param {Insight_Progress_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_progress_load = /** @type {((inputs: Insight_Progress_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Progress_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_progress_load(inputs)
	if (locale === "es-419") return es_419_insight_progress_load(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_progress_load(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_progress_load(inputs)
	if (locale === "de-DE") return de_de2_insight_progress_load(inputs)
	if (locale === "it-IT") return it_it2_insight_progress_load(inputs)
	return en_us2_insight_progress_load(inputs)
});
export { insight_progress_load as "insight.progress_load" }